import React, { useState } from 'react';
import { TopBar } from './components/TopBar';
import { ScenarioSelector } from './components/ScenarioSelector';
import { ScenarioComparison } from './components/ScenarioComparison';
import { AddOns } from './components/AddOns';
import { ScenarioDetails } from './components/ScenarioDetails';
import { ShippingDiscounts } from './components/ShippingDiscounts';
import { OperationsEconomy } from './components/OperationsEconomy';
import { TermsNotes } from './components/TermsNotes';
import { StickyBottomBar } from './components/StickyBottomBar';
export function App() {
  const [showVat, setShowVat] = useState(true);
  const [selectedScenario, setSelectedScenario] = useState('better');
  const [showComparison, setShowComparison] = useState(false);
  const [addOns, setAddOns] = useState({
    wifiThermostats: false,
    energyMonitoring: false,
    serviceAgreement: false,
    extendedWarranty: false,
    expressDelivery: false
  });
  const scenarios = {
    good: {
      name: 'GOOD',
      badge: 'Laveste pris',
      basePrice: 169900,
      monthlyPayment: 1249,
      eta: '5-7 hverdage',
      stock: 'På lager',
      manifold: 'Roth gulvvarmefordeler 4 afgr.',
      pipes: 'Roth X-PERT S5® 16 mm, c/c 200 mm, 800 m',
      thermostats: 'Kablede termostater, 4 zoner',
      pump: 'Standard shunt og pumpe',
      ventilation: 'Ikke inkluderet'
    },
    better: {
      name: 'BETTER',
      badge: 'Mest valgt',
      basePrice: 189500,
      monthlyPayment: 1399,
      eta: '7-10 hverdage',
      stock: 'Delvist på lager',
      manifold: 'Roth gulvvarmefordeler 6 afgr.',
      pipes: 'Roth X-PERT S5® 16 mm, c/c 150 mm, 1000 m',
      thermostats: 'Roth Touchline® SL, 6 zoner',
      pump: 'Shunt med termostatisk ventil',
      ventilation: 'Basismodel, filterklasse F7'
    },
    best: {
      name: 'BEST',
      badge: 'Højeste komfort',
      basePrice: 219900,
      monthlyPayment: 1599,
      eta: '2-3 uger',
      stock: 'Bestillingsvare',
      manifold: 'Roth gulvvarmefordeler 8 afgr.',
      pipes: 'Roth X-PERT S5® 20 mm, c/c 100 mm, 1200 m',
      thermostats: 'Roth Touchline® SL WiFi, 8 zoner',
      pump: 'Premium shunt og energibesparende pumpe',
      ventilation: 'Premium model, filterklasse F9, støjsvag'
    }
  };
  const addOnPrices = {
    wifiThermostats: 4500,
    energyMonitoring: 3200,
    serviceAgreement: 2400,
    extendedWarranty: 5800,
    expressDelivery: 1200
  };
  const calculateTotalPrice = () => {
    const basePrice = scenarios[selectedScenario].basePrice;
    const addOnTotal = Object.keys(addOns).reduce((total, key) => {
      return total + (addOns[key] ? addOnPrices[key] : 0);
    }, 0);
    return basePrice + addOnTotal;
  };
  const formatPrice = price => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  };
  return <div className="bg-gray-50 min-h-screen w-full pb-24" data-id="element-0">
      <TopBar showVat={showVat} setShowVat={setShowVat} data-id="element-1" />
      <main className="container mx-auto px-4 py-6 space-y-8" data-id="element-2">
        <ScenarioSelector scenarios={scenarios} selectedScenario={selectedScenario} setSelectedScenario={setSelectedScenario} showComparison={showComparison} setShowComparison={setShowComparison} formatPrice={formatPrice} showVat={showVat} data-id="element-3" />
        {showComparison && <ScenarioComparison scenarios={scenarios} formatPrice={formatPrice} showVat={showVat} data-id="element-4" />}
        <AddOns addOns={addOns} setAddOns={setAddOns} addOnPrices={addOnPrices} formatPrice={formatPrice} data-id="element-5" />
        <ScenarioDetails scenario={scenarios[selectedScenario]} formatPrice={formatPrice} showVat={showVat} data-id="element-6" />
        <ShippingDiscounts formatPrice={formatPrice} showVat={showVat} data-id="element-7" />
        <OperationsEconomy selectedScenario={selectedScenario} formatPrice={formatPrice} data-id="element-8" />
        <TermsNotes data-id="element-9" />
      </main>
      <StickyBottomBar totalPrice={calculateTotalPrice()} selectedScenario={scenarios[selectedScenario]} addOns={addOns} addOnPrices={addOnPrices} formatPrice={formatPrice} showVat={showVat} data-id="element-10" />
    </div>;
}